import {
    SIGNALR,
    SIGNALR_SET,
    SIGNALR_SET_SUCCESS,
    SIGNALR_SET_TRIGGER,
    SIGNALR_ACCOUNTS_REFRESH
} from "../actionType";

const INITIAL_STATE = {
    signalAchDelayedMsg: {},
    signalBankCalloutMsg: [],
    accountsRefreshAt: null
};

const theme = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case SIGNALR:
            return {
                ...state,
            };

        case SIGNALR_SET_TRIGGER:
            return action.payload;
        case SIGNALR_SET_SUCCESS:
            return action.payload;
        case SIGNALR_ACCOUNTS_REFRESH:
            return { ...state, accountsRefreshAt: action.payload };
        default:
            return state;
    }
};
export default theme;